import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { ModalClose } from '../ModalClose'
import Button from '../Button'

export const Modal = styled.div`
  display: flex;
  position: relative;

  ${Media.Phone`
    margin-top: auto;
  `}
`

export const Container = styled.div`
  display: flex;
  background-color: ${Colors.White};
  border-radius: ${Spacing.S};
  width: 500px;
  max-width: calc(100vw - 40px);
  overflow: hidden;
  position: relative;

  ${Media.Tablet`
    border-radius: ${Spacing.S};
 `}

  ${Media.Phone`
    display: block;
    width: 100%;
    max-width: none;
    max-height: calc(100vh - 68px);
    border-radius: ${Spacing.S} ${Spacing.S} 0 0;
    overflow: auto;
  `}
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${Spacing.L};
  flex: 0 0 100%;
  gap: ${Spacing.L};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.M};
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.L};
  padding-right: 28px;
`

export const EmailImage = styled.img`
  width: 97px;
`

export const Title = styled.div`
  ${Typography.S};
  ${FontWeights.DemiBold};
`

export const EmailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.XS};
`

export const ConsentCheckboxWrapper = styled.div`
  color: ${Colors.Neutral50};
`

export const Footer = styled.div`
  display: flex;
  gap: ${Spacing['2XS']};
  justify-content: flex-end;
`

export const StyledButton = styled(Button)`
  ${Media.Phone`
    flex: 1 1 50%;
  `}
`

export const Copyright = styled.div`
  ${Typography.Caption};
  color: ${Colors.Neutral50};

  a {
    color: ${Colors.Blue50};
  }

  a:hover {
    color: ${Colors.Blue70};
  }
`

export const CloseButton = styled(ModalClose)`
  position: absolute;
  top: 32px;
  right: 32px;

  ${Media.Phone`
    top: 20px;
    right: 20px;
  `}
`
